module.exports = __webpack_public_path__ + "./img/circle-512-blur.svg";